<template lang="pug">
.l-article-easyinfo(
    :style="styleObjectModal"
    :class="{hotoke:store.ui.state.hotoke}"
    @click="click"
  )
  .l-article-easyinfo__arrow
  .l-article-easyinfo__box
    .l-article-easyinfo__box__info
      .l-article-easyinfo__box__info__img(:style="styleObjectEasyInfo")
      .l-article-easyinfo__box__info__desc
        p.l-article-easyinfo__box__info__desc__title {{store.ui.state.easyinfo.mapdata.name}}
        p.l-article-easyinfo__box__info__desc__kana {{store.ui.state.easyinfo.mapdata.kana}}
        .l-article-easyinfo__box__info__desc__bunkazai(v-if="store.ui.state.easyinfo.mapdata.bunkazai && store.ui.state.easyinfo.mapdata.bunkazai.length > 0")
          p.l-article-easyinfo__box__info__desc__bunkazai__item(v-for="bunkazai in store.ui.state.easyinfo.mapdata.bunkazai") {{bunkazai}}
    //- a.l-article-easyinfo__box__btn もっと見る

</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-article-easyinfo
  +pc()
    display none
  
  background-color #f6f5f1
  no_highlight()
  wh(680px,305px)
  posb(35px,-305px,89)
  border-radius 20px 20px 0 0
  transition transform 550ms $easeOutExpo
  box-shadow 0 4px 9px rgba(150,150,150,0.5)

  &.hotoke
    background-color #3d3d3d
    color #FFF
  
  &__line
    wh(90px,10px)
    background-color #c0c0c0
    border-radius 5px
    margin 20px auto
  &__arrow
    pos(0,27px)
    wh(30px,20px)
    left calc(50% - 15px)
    ^[0].hotoke &
      &:before,
      &:after
        background-color #FFF
    &:before,
    &:after
      content ""
      background-color #404040
      width 19px
      height 1.5px
      position absolute
      top 0
    &:before
      right 15px
      transform-origin right
      transform rotate(-45deg)
    &:after
      left 15px
      transform-origin left
      transform rotate(45deg)


  &__box
    width 610px
    margin 0 auto
    padding-top 65px
    &__info
      display flex
      justify-content space-between
      &__img
        wh(250px,188px)
        background-size cover
        border-radius 20px
      &__desc
        width 330px
        display flex
        align-content center
        align-items center
        flex-wrap wrap
        &__title
          width 100%
          font-size 32px
          font-weight bold
        &__kana
          width 100%
          font-size 20px
          margin-top 18px
          &:before
            content "【"
            margin-left -8px
          &:after
            content "】"
        &__bunkazai
          display flex
          justify-content flex-start
          margin-top 18px
          &__item
            background-color #dd4517
            color #FFF
            font-weight bold
            border-radius 8px
            margin-left 15px
            ^[0].hotoke &
              background-color #5f5f5f
            &:first-child
              margin-left 0
            font-size 20px
            height 40px
            line-height 40px
            padding 0 23px
    &__btn
      wh(180px,60px)
      display block
      margin 18px auto 0
      background-color #FFF
      border 2px solid #e6e6e6
      border-radius 20px
      line-height 60px
      text-align center
      font-size 21px
      font-weight bold

</style>


<script>
import { defineComponent, computed, ref, onMounted, reactive } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name:'ArticleEasyInfo',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()


    const click = ()=> {
      store.ui.state.easyinfo.mapdata.id
      store.ui.state.easyinfo.show = false
      router.push('/article/'+store.ui.state.easyinfo.mapdata.id)
    }
    const styleObjectModal = computed(()=>{
      let obj = {}
      if(store.ui.state.easyinfo.show){
        // obj.bottom = 0
        obj.transform = 'translateY(-305px)'
      }
      return obj
    })
    const styleObjectEasyInfo = computed(()=>{
      let obj = {}
      if(store.ui.state.easyinfo.mapdata.thumbnail){
        obj.backgroundImage = 'url('+ store.ui.state.easyinfo.mapdata.thumbnail + ')'
      }
      return obj
    })
    const show = computed(()=>{
      if(store.ui.state.article.show){
        return false
      } else {
        if(!store.ui.state.easyinfo.show){
          return false
        }
      }
      return true
    })
    
    return{
      click,
      styleObjectModal,
      styleObjectEasyInfo,
      show,
      store
    }
  }
})
</script>
